import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

import { ExercisePreviewPage } from "pages/ExercisePreviewPage";
import { LoginPage } from "pages/LoginPage";
import { PracticePage } from "pages/PracticePage";
import { ProfilePage } from "pages/ProfilePage";
import { SignupPage } from "pages/SignupPage";
import { SummaryPage } from "pages/SummaryPage";

function PrivateRoute({ component: Component, ...rest }) {
  const {user} = useAuth();
  if (user === undefined) {
    return "Logging in...";
  }
  return (
    <Route
      {...rest}
      render={props =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export default (
  <Switch>
    <Redirect exact path="/" to="/profile" />
    <Route exact path="/login" component={LoginPage} />
    <Route exact path="/signup" component={SignupPage} />
    <PrivateRoute exact path="/profile" component={ProfilePage} />
    <PrivateRoute exact path="/practice" component={PracticePage} />
    <PrivateRoute
      exact
      path="/preview/:index"
      component={ExercisePreviewPage}
    />
    <PrivateRoute exact path="/summary/preview/:levelUp" component={SummaryPage} />
    <PrivateRoute exact path="/summary/:length" component={SummaryPage} />
  </Switch>
);
